export default __webpack_public_path__ + "img/xOZsTaFe.ada017c9.svg";